/**
 * @copyright © Paramount Streaming
 * @description Brand identifier enum for Smart Tag (shared by Tag and Skin layers).
 */
export enum Brand {
	PPLUS = 'pplus',
	PLUTOTV = 'plutotv',
	CBS = 'cbs',
}